import { compute_data_root_fields } from './get_compute_data';
import {
  last_transaction_selection,
  promocode_options_selection,
} from './get_customer_last_transaction_promocodes_data';
import {
  available_currencies_selection,
  customer_amount_first_selection,
} from './get_customer_currencies_transaction_promocodes_data';
import { withdrawal_requests_selection } from './get_withdrawl_requests';

export const get_initial_data_amount_first_query = `
  query Get_initial_data_amount_first {${compute_data_root_fields}
    customer {${customer_amount_first_selection}}
    available_currencies {${available_currencies_selection}}
    last_transaction {${last_transaction_selection}}
    promocode_options {${promocode_options_selection}}
    withdrawal_requests {${withdrawal_requests_selection}}
  }
`;

// Used only after a reload of a session in which the player had already
// switched tab: the tab-specific fields then carry the active tab's intent.
// Before any switch the query above is sent unchanged.
export const get_initial_data_amount_first_active_intent_query = `
  query Get_initial_data_amount_first($active_intent: CashierIntent) {${compute_data_root_fields}
    customer {${customer_amount_first_selection}}
    available_currencies(active_intent: $active_intent) {${available_currencies_selection}}
    last_transaction(active_intent: $active_intent) {${last_transaction_selection}}
    promocode_options {${promocode_options_selection}}
    withdrawal_requests {${withdrawal_requests_selection}}
  }
`;
